import React, { useState } from 'react';
import filter from 'lodash/filter';
import forEach from 'lodash/forEach';

import BusinessHours from 'src/models/BusinessHours/BusinessHours';
import BusinessHoursReference, { EntityType } from 'src/models/BusinessHours/BusinessHoursReference';
import BusinessHoursReferencesModal from 'src/presentation/components/pages/businessHours/components/BusinessHoursReferencesModal';

export type BusinessHoursReferenceLink = {
  id: string;
  link: string;
  name: string;
  type: EntityType;
};

const LINKS_MAP = {
  [EntityType.RULE]: {
    getLink: (ruleId: string) => `rules/${ruleId}`,
  },
};

const getReferences = (references: BusinessHoursReference[], type: EntityType): BusinessHoursReferenceLink[] => {
  const transformedRefs: BusinessHoursReferenceLink[] = [];
  const refRules = filter(references, ref => ref.type === type);
  const linkMap = LINKS_MAP[type];

  forEach(refRules, refRule => {
    transformedRefs.push({
      id: refRule.id,
      link: linkMap.getLink(refRule.id),
      name: refRule.name,
      type: refRule.type,
    });
  });

  return transformedRefs;
};

const useShowReferences = () => {
  const [item, setItem] = useState<BusinessHours>();
  const [referencesLinks, setReferencesLinks] = useState<BusinessHoursReferenceLink[]>();
  const [showModal, setShowModal] = useState(false);

  const openModal = (item, references) => {
    const transformedRefs = [...getReferences(references, EntityType.RULE)];
    setReferencesLinks(transformedRefs);
    setItem(item);
    setShowModal(true);
  };
  const closeModal = () => setShowModal(false);

  const renderModal = showModal ? (
    <BusinessHoursReferencesModal item={item} onCancel={closeModal} references={referencesLinks} />
  ) : null;

  return { renderModal, openModal };
};

export default useShowReferences;
